import { render } from "./index.vue?vue&type=template&id=167c2b9b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=167c2b9b&lang=less&scoped=true"

import exportComponent from "/root/workspace/__flow_work/__flow_builds/3fa629ad-4e49-4135-b708-61865bcdea83/workspace/moon_eoR5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-167c2b9b"]])

export default __exports__